import { Meta } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { ExtendButton, TerminateButton } from './OngoingParkingComponents';
import { useUiStore } from 'stores/uiStore';

const ActionContainer = styled.View`
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
  min-height: 240px;
`;
const ActionWrapper = styled.View`
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-shrink: 0;
`;

const Column = styled.View`
  margin: ${isWeb ? '0' : '20'}px 30px;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const StopText = styled(Meta)`
  color: ${({ theme }) => theme.colors.white};
`;

const OngoingParkingActions = ({
  onShowExtendTime,
  showExtendButton,
}: {
  onShowExtendTime: () => void;
  showExtendButton: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <ActionContainer {...testIdentifiers('ongoing-parking-expanded-actions')}>
      <ActionWrapper>
        <Column>
          {showExtendButton && <ExtendButton set onPress={onShowExtendTime} />}
        </Column>
        <Column>
          <TerminateButton
            testID="ongoing-parking-expanded-actions-stop-parking"
            onPress={() =>
              useUiStore.getState().setSheetModal('stopOngoingParking')
            }
            bigger
          />
        </Column>
        <Column>
          {showExtendButton && (
            <ExtendButton
              onPress={() =>
                useUiStore.getState().setSheetModal('extendOngoingParking')
              }
            />
          )}
        </Column>
      </ActionWrapper>
      <StopText testID="ongoing-parking-expanded-actions-text">
        {t('parking.stopParking')}
      </StopText>
    </ActionContainer>
  );
};

export default OngoingParkingActions;
